import gql from 'graphql-tag';
import { postGQLFields } from './posts.fields.js';
export function createReplyGQLQuery(fields) {
    return gql `
    mutation createReply($postId: ID!, $input: CreatePostInput!) {
      createReply(postId: $postId, input: $input) {
        ${postGQLFields(fields)}
      }
    }
  `;
}
//# sourceMappingURL=reply.gql.js.map